import React from 'react';

import { ConnectedSpaceInfoProvider } from '~src/spacesPlatform/components/Explorer/helpers/SpaceInfoProvider';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '~src/spacesPlatform/state/SpaceInfo';

import { ConnectedQueryParamUpdateProvider } from '../../bootstrap/routerHelpers/QueryParamUpdateProvider';
import { ConnectedPredictiveModelEditorSpace } from './ConnectedPredictiveModelEditorSpace';
import { PredictiveModelEditorSpaceOwnProps } from './PredictiveModelEditorSpace';

//SpaceProviderProps provides and passes the props that would be used for the predictive model space
export interface PredictiveModelEditorSpaceProviderProps extends PredictiveModelEditorSpaceOwnProps {
  readonly routeLocationPath: string;
  readonly routeLocationSearch: string;
}

const PredictiveModelEditorSpaceInfo: SpaceInfo = {
  item: SpaceItemForNonEntitySpace,
  spaceType: 'predictiveModel',
  subspaceName: undefined
};

export const PredictiveModelEditorSpaceProvider: React.FunctionComponent<PredictiveModelEditorSpaceProviderProps> = (props) => {
  return (
    <ConnectedSpaceInfoProvider spaceInfo={PredictiveModelEditorSpaceInfo}>
      <ConnectedQueryParamUpdateProvider
        routeLocationPath={props.routeLocationPath}
        routeLocationSearch={props.routeLocationSearch}
        shouldUpdateBreadcrumbs={false}
        shouldUpdateContentTypes={true}
        shouldUpdateFilters={true}
        shouldUpdateSort={true}
      >
        <ConnectedPredictiveModelEditorSpace {...{...props}}/>
      </ConnectedQueryParamUpdateProvider>
    </ConnectedSpaceInfoProvider>
  );
};
